import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import MobileModal from '../mobile_modal';
import RoundsModalContainer from '../../containers/rounds_modal_container';
import RoundPickerTrigger from '../round_picker_trigger';
import { expandRoundName, expandedRoundLabel } from '../../utils/round_label_utils';

const DetailsRoundModal = ({ rounds, roundDates, selectedRoundId, onRoundChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);
  const selectedRound = rounds.find((r) => String(r.id) === selectedRoundId);

  const handleOpen = () => {
    setIsOpen(true);
    modalRef.current?.open();
  };

  // Stable for the connected rounds modal: opening and closing re-renders this
  // trigger, which would otherwise hand the modal a new function each time.
  const handleRoundChange = useCallback((newRoundId) => {
    onRoundChange(newRoundId);
    setIsOpen(false);
    modalRef.current?.close();
  }, [onRoundChange]);

  return (
    <div className="lbv2__round-selector">
      <RoundPickerTrigger
        label={expandRoundName(selectedRound?.name ?? 'R1')}
        date={roundDates?.[selectedRound?.id]}
        isOpen={isOpen}
        showPlayAt
        onClick={handleOpen}
      />
      <MobileModal ref={modalRef} onClose={() => setIsOpen(false)} type="lbv2__aggregate-rounds">
        <RoundsModalContainer
          rounds={rounds}
          roundId={selectedRoundId}
          onRoundChange={handleRoundChange}
          formatLabel={expandedRoundLabel}
        />
      </MobileModal>
    </div>
  );
};

DetailsRoundModal.propTypes = {
  rounds: PropTypes.array.isRequired,
  roundDates: PropTypes.object,
  selectedRoundId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRoundChange: PropTypes.func.isRequired,
};

export default DetailsRoundModal;
